export default {
  colors: [],
  color: {},
};
